import Entity from "./Entity";

export default class Size extends Entity {

    constructor(data) {
        super(data);

        this.attributeKeys = [ "width", "height" ];
    }
}